// extracted by mini-css-extract-plugin
module.exports = {"Container":"Signup_Container__E7Fk3","CardBody":"Signup_CardBody__3HhCl","FormGroup":"Signup_FormGroup__3bRuf","BtnSubmit":"Signup_BtnSubmit__3V8Ng","Login":"Signup_Login__1WLSr"};